import type { BillingInterval, CheckoutTier, PortalFlow } from "./types"

export const BILLING_API_BASE_URL =
  process.env.NEXT_PUBLIC_BILLING_API_BASE_URL ?? ""

export const AWS_MARKETPLACE_ONBOARDING_ERROR_CODES = {
  ALREADY_CLAIMED: "ALREADY_CLAIMED",
  ENTITLEMENT_INACTIVE: "ENTITLEMENT_INACTIVE",
  FULFILLMENT_REQUIRED: "FULFILLMENT_REQUIRED",
  INVALID_TOKEN: "INVALID_TOKEN",
  ORGANIZATION_CONFLICT: "ORGANIZATION_CONFLICT",
} as const

interface TierPricing {
  amountUsdPerMonth: number
  priceLabel: string
  cadenceLabel: string
  billedAsLabel: string | null
}

interface TierDefinition {
  id: CheckoutTier
  label: string
  minutesLabel: string
  metricsLabel: string
  pricing: Record<BillingInterval, TierPricing>
}

const ANNUAL_DISCOUNT_PERCENT = 20

export const TIER_DEFINITIONS: TierDefinition[] = [
  {
    id: "starter",
    label: "Starter",
    minutesLabel: "100 simulation minutes",
    metricsLabel: "up to 10 metrics per evaluation",
    pricing: {
      month: {
        amountUsdPerMonth: 100,
        priceLabel: "$100",
        cadenceLabel: "/month",
        billedAsLabel: null,
      },
      year: {
        amountUsdPerMonth: 80,
        priceLabel: "$80",
        cadenceLabel: "/month",
        billedAsLabel: "Billed $960/year",
      },
    },
  },
  {
    id: "growth",
    label: "Growth",
    minutesLabel: "1,000 simulation minutes",
    metricsLabel: "unlimited metrics per evaluation",
    pricing: {
      month: {
        amountUsdPerMonth: 500,
        priceLabel: "$500",
        cadenceLabel: "/month",
        billedAsLabel: null,
      },
      year: {
        amountUsdPerMonth: 400,
        priceLabel: "$400",
        cadenceLabel: "/month",
        billedAsLabel: "Billed $4,800/year",
      },
    },
  },
]

export const BILLING_INTERVAL_OPTIONS: ReadonlyArray<{
  id: BillingInterval
  label: string
  badge: string | null
}> = [
  { id: "month", label: "Monthly", badge: null },
  { id: "year", label: "Annual", badge: `Save ${ANNUAL_DISCOUNT_PERCENT}%` },
]

export const POLL_INTERVAL_AGGRESSIVE_MS = 2_000
export const POLL_INTERVAL_FALLBACK_MS = 5_000
export const POLL_AGGRESSIVE_DURATION_MS = 30_000
export const POLL_TOTAL_TIMEOUT_MS = 90_000

export const NEAR_LIMIT_THRESHOLD = 0.8

export const PORTAL_FLOW: Record<
  | "manageSubscription"
  | "cancelSubscription"
  | "viewInvoices"
  | "updatePayment",
  PortalFlow
> = {
  manageSubscription: "subscription_update",
  cancelSubscription: "subscription_cancel",
  viewInvoices: "invoice_history",
  updatePayment: "payment_method_update",
}
